import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TrendingUp, Clock, Target, Star, Zap } from 'lucide-react';
import { BenefitCard } from './BenefitCard';
import { fadeInUp, smoothTransition } from './animations';

const benefits = [
  {
    id: 'benefit-ticket',
    icon: TrendingUp,
    title: 'Aumenta el ticket promedio sin esfuerzo',
    description: 'Destaca productos estratégicos y guía la decisión del cliente hacia mayor consumo',
    image: 'https://images.unsplash.com/photo-1623073284788-0d846f75e329',
  },
  {
    id: 'benefit-time',
    icon: Clock,
    title: 'Reduce el tiempo de decisión',
    description: 'Navegación intuitiva que acelera el proceso de pedido y mejora la rotación',
    image: 'https://images.unsplash.com/photo-1541832676-9b763b0239ab',
  },
  {
    id: 'benefit-strategic',
    icon: Target,
    title: 'Vende más productos estratégicos',
    description: 'Organización diseñada para impulsar tus platos de mayor margen',
    image: 'https://images.pexels.com/photos/6880543/pexels-photo-6880543.jpeg',
  },
  {
    id: 'benefit-experience',
    icon: Star,
    title: 'Mejora la experiencia del cliente',
    description: 'Interfaz moderna y profesional que eleva la percepción de tu marca',
    image: 'https://images.pexels.com/photos/2792186/pexels-photo-2792186.jpeg',
  },
  {
    id: 'benefit-modern',
    icon: Zap,
    title: 'Moderniza tu negocio en días',
    description: 'Implementación rápida sin complicaciones técnicas ni interrupciones',
    image: 'https://images.unsplash.com/photo-1600147131759-880e94a6185f',
  },
];

export const Benefits = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const headerAnimation = useMemo(() => ({
    ...fadeInUp,
    animate: inView ? fadeInUp.animate : fadeInUp.initial,
  }), [inView]);

  return (
    <section ref={ref} className="py-20 sm:py-28 relative">
      <div className="container px-4 sm:px-6 lg:px-8">
        <motion.div
          {...headerAnimation}
          transition={smoothTransition}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            Con <span className="text-primary">Zappien SmartMenu™</span> puedes
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.slice(0, 3).map((benefit, index) => (
            <BenefitCard
              key={benefit.id}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
              image={benefit.image}
              index={index}
            />
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mt-6 max-w-4xl mx-auto">
          {benefits.slice(3).map((benefit, index) => (
            <BenefitCard
              key={benefit.id}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
              image={benefit.image}
              index={index + 3}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
